import Header from './Header';
import ImageSlider from './ImageSlider';
import Equipment from './Equipment';
import Ingredients from './Ingredients';
import Instructions from './Instructions';
import './scss/App.scss';
import './scss/Intro.scss';
import './scss/Settings.scss';
import finishedDish from './media/finished.png';
import image1 from './media/image1.webp';
import image2 from './media/image2.webp';

function App() {
  const images = [finishedDish, image1, image2];

  return (
    <>
    {/* HEADER */}
    <Header />

    <div id="recipe-sidebar-container">
      <div id="recipe-container">  
        {/* INTRO */}
        <section id="intro">
          <header>
            <h1>Springtime Saffron Pasta</h1>
            <h4><i>Pasta with peas and asparagus, in a saffron cream sauce, topped with lemon zest, parmesan, and herbs</i></h4>
            <p className="subtitle">Total time: 1 hour, 15 minutes • Vegetarian</p>
          </header>
          <ImageSlider images={images} />
          <details className="read-more">
            <summary>This recipe is all about springtime flavors. It was adapated from a <a href="" target="_blank">Green's Cookbook</a> recipe. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. <span className="read-more-contents"> Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </span></summary>
          </details>
        </section>

        <Equipment />
        
        {/* SETTINGS */}
        <section id="settings">
          <select name="servings" defaultValue="4">
            <option value="2">2 servings</option>
            <option value="4">4 servings</option>
            <option value="8">8 servings</option>
            <option value="12">12 servings</option>
            <option value="24">24 servings</option>
            <option value="custom">Custom</option>
          </select>
          <select name="measurements">
            <option value="us">US measurements</option>
            <option value="metric">Metric</option>
          </select>
        </section>

        <div id="ingredients-instructions-wrapper">
          {/* INGREDIENTS */}
          <Ingredients />

          {/* INSTRUCTIONS */}
          <Instructions />
        </div>  
      </div>

      <div id="sidebar"><p>(optional sidebar — about, social media, etc.)</p></div>
    </div>
    </>
  );
}

export default App;
